import { useContext } from 'react';

import { SwipeableViewsContext } from '../context';
import { SwipeableViewsState } from '../types';

export const useSwipeableViews = (): SwipeableViewsState | undefined =>
  useContext(SwipeableViewsContext);
